/**
 * WordPress Core Deps
 */

const variations = [];

Object.keys( window.portal_lucide_icons ).forEach( ( key ) => {
	let iconInstance = {};

	const Icon = () => {
		return <span className="portal-lucide-icon" dangerouslySetInnerHTML={ { __html: window.portal_lucide_icons[ key ].rendered } } />;
	};

	if ( 'Box' === key ) {
		iconInstance = {
			isDefault: true,
			name: key,
			attributes: { service: key },
			title: key,
			icon: Icon,
		};
	} else {
		iconInstance = {
			name: key,
			attributes: { service: key },
			title: key,
			icon: Icon,
		};
	}

	variations.push( iconInstance );
} );

/**
 * Add `isActive` function to all `social link` variations, if not defined.
 * `isActive` function is used to find a variation match from a created
 *  Block by providing its attributes.
 */
variations.forEach( ( variation ) => {
	if ( variation.isActive ) {
		return;
	}
	variation.isActive = ( blockAttributes, variationAttributes ) =>
		blockAttributes.service === variationAttributes.service;
} );

export default variations;
